import KogCheckbox from '@/main/components/shared/checkbox/kogCheckbox';
import {
  KOGTableCell,
  KOGTableRow
} from '@/main/components/shared/kogBoxGrid/styles';
import WrapperQuoteProcurementPartInfo from '@/main/components/shared/quoteProcurementPartInfo/quoteProcurementPartInfo';
import { TextEllipsis } from '@/main/components/shared/styles';
import { PartsCancelledSearchResponse } from '@/main/models/response';
import { RoutesConstants } from '@/main/routes/routesConstants';
import { getTranslateByKey, isNullUndefinedEmpty } from '@/main/services/utils';
import { getStartandFinalDateByString } from '@/main/services/utilsDate';
import { formatCurrency } from '@/main/services/utilsNumber';
import { toast } from 'react-toastify';
import * as S from './styles';

interface IRowCancelledPart {
  part: PartsCancelledSearchResponse;
  isSelected: boolean;
  disableSelect: boolean;
  handleChangeSelection: (quoteGuid: string) => void;
  maxSelect: number;
  index: number;
}

function goToSearchOrder(filter: string, date: string) {
  const { finalDate, startDate } = getStartandFinalDateByString(date);
  return `${RoutesConstants.orderSearchOrder}?quoteFilterVehicle=${filter}&startDate=${startDate}&finalDate=${finalDate}`;
}

export default function RowCancelledPart({
  part,
  isSelected,
  disableSelect,
  handleChangeSelection,
  maxSelect,
  index
}: Readonly<IRowCancelledPart>) {
  const handleClickQuoteNumber = (part: PartsCancelledSearchResponse) => {
    if (!isNullUndefinedEmpty(part.procurementCode)) {
      const url = goToSearchOrder(
        String(part.procurementCode),
        String(part.procurementDate || '')
      );
      window.open(`#${url}`, '_blank');
      return;
    }

    if (!isNullUndefinedEmpty(part.quoteCode)) {
      const url = goToSearchOrder(
        String(part.quoteCode),
        String(part.procurementDate || '')
      );
      window.open(`#${url}`, '_blank');
    }
  };

  return (
    <KOGTableRow
      $notHover
      $notClickable
      $isSizeLong
      id={`id-searchPartsCancelled-row-${index}`}>
      <KOGTableCell align="center" style={{padding: "2px 16px"}}>
        <button
          type="button"
          onClick={() => {
            if (disableSelect) {
              toast.warn(
                getTranslateByKey('information.maximumXPartsReached').replace(
                  '{0}',
                  String(maxSelect)
                )
              );
              return;
            }
            handleChangeSelection(part.procurementSupplierItemGuid);
          }}
          style={{ all: 'unset' }}>
          <KogCheckbox disabled={disableSelect} checked={isSelected} />
        </button>
      </KOGTableCell>
      <KOGTableCell>
        <TextEllipsis title={part.claimNumber}>{part.claimNumber}</TextEllipsis>
      </KOGTableCell>
      <KOGTableCell>
        <S.Link
          onClick={() => handleClickQuoteNumber(part)}
          id={`id-searchPartsCancelled-row-link-${index}`}>
          <TextEllipsis title={`${part.procurementCode} / ${part.quoteCode}`}>
            {part.procurementCode} / {part.quoteCode}
          </TextEllipsis>
        </S.Link>
      </KOGTableCell>
      <KOGTableCell>
        <TextEllipsis title={part.vehicleFullName}>
          {part.vehicleFullName}
        </TextEllipsis>
      </KOGTableCell>

      <KOGTableCell>
        <TextEllipsis title={part.insurerName}>{part.insurerName}</TextEllipsis>
      </KOGTableCell>

      <KOGTableCell>
        <TextEllipsis title={part.bodyShopName}>
          {part.bodyShopName}
        </TextEllipsis>
      </KOGTableCell>

      <KOGTableCell>
        <TextEllipsis title={part.supplierName}>
          {part.supplierName}
        </TextEllipsis>
      </KOGTableCell>

      <KOGTableCell>
        <S.PartCellContent>
          <WrapperQuoteProcurementPartInfo
            data={part.quoteProcurementPartInfo}
            renderType="column"
            isTooltip
          />
        </S.PartCellContent>
      </KOGTableCell>

      <KOGTableCell align="center">
        {/* <TextEllipsis title={part.canceledDateFormatted}> */}
          {part.canceledDateFormatted}
        {/* </TextEllipsis> */}
      </KOGTableCell>
      <KOGTableCell align="right">
        {/* <TextEllipsis title={formatCurrency(part.totalPrice)}> */}
          {formatCurrency(part.totalPrice)}
        {/* </TextEllipsis> */}
      </KOGTableCell>
    </KOGTableRow>
  );
}
